// Module
var code = "<template>\n  <div class=\"col label-value\">\n    <span style=\"opacity: 0.75\" t=\"${label}\"></span>\n    <p title.bind=\"label\" style=\"display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis\">\n      ${value}\n      <slot></slot>\n    </p>\n  </div>\n</template>\n";
// Exports
export default code;